// Default invalid credit card fields object
export const INVALID_CREDIT_CARD_FIELDS = {
  cardNumber: false,
  cardExpiry: false,
  cardCvv: false,
  card: false,
  billingAddress: false,
  state: false,
};

/**
 * Takes the output of findBadParams and returns the invalidCardFields object
 */
export function getInvalidCardFieldsFromBadParams(badParams) {
  const invalidCardFields = { ...INVALID_CREDIT_CARD_FIELDS };

  if (badParams.isCardNumberInvalid || (Array.isArray(badParams) && badParams.includes('cardNumber'))) {
    invalidCardFields.cardNumber = true;
  }
  if (badParams.isCardExpDateInvalid || (Array.isArray(badParams) && badParams.includes('cardExpiry'))) {
    invalidCardFields.cardExpiry = true;
  }
  if (badParams.isCardCvvInvalid || (Array.isArray(badParams) && badParams.includes('cardCvv'))) {
    invalidCardFields.cardCvv = true;
  }

  // If any card field is invalid, mark the whole card as invalid
  if (invalidCardFields.cardNumber || invalidCardFields.cardExpiry || invalidCardFields.cardCvv) {
    invalidCardFields.card = true;
  }

  // Optionally handle billingAddress/state if needed
  if (Array.isArray(badParams) && badParams.includes('billingAddress')) {
    invalidCardFields.billingAddress = true;
  }
  if (Array.isArray(badParams) && badParams.includes('state')) {
    invalidCardFields.state = true;
  }

  return invalidCardFields;
}

// This function handles the mutation result and calls the appropriate callbacks
export function handleMutationResult(result, onPaymentSuccess, onPaymentError) {
  if (result?.success) {
    if (onPaymentSuccess) {
      onPaymentSuccess(result?.userMessage);
    }
    return;
  }
  if (onPaymentError) {
    onPaymentError(result?.userMessage);
  }
}

// This function handles the form reset logic when payment update is completed
export function handlePaymentUpdateCompleted(data, setHasValidationError, setCardDetails, setBillingAddress, onPaymentSuccess, onPaymentError) {
  const result = data?.updateOrderPayment;

  // Reset form state
  setHasValidationError(INVALID_CREDIT_CARD_FIELDS);
  setCardDetails({
    cardNumber: '',
    expirationDate: '',
    securityCode: '',
    cardBrand: '',
    formattedNumber: '',
    code: '021',
  });
  setBillingAddress({
    country: '',
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
  });

  // Handle the mutation result
  handleMutationResult(result, onPaymentSuccess, onPaymentError);
}
